/**
 * Extract a readable section label from an eCTD filename.
 *
 * Prefers the CTD section number (e.g. "2.5", "3.2.P.1") when the
 * filename starts with one; falls back to a truncated name without
 * the .docx extension.
 */
export function formatSectionLabel(filename: string): string {
  const nameWithoutExt = filename.replace(/\.docx$/i, '');
  const match = nameWithoutExt.match(/^(\d+(?:\.[\dA-Za-z]+)+)/);
  if (match) return match[1];
  return nameWithoutExt.length > 20
    ? nameWithoutExt.slice(0, 20) + '\u2026'
    : nameWithoutExt;
}
